export enum TimeclockState {
  InitialState,
  TimeclockStarted,
  TimeclockCheckedIn,
  TimeclockCheckedOut,
  TimeclockEnded,
  BreaktimeStarted,
  BreaktimeEnded,
}
